<template>
  <div>
    <form
      method="post"
      class="search-zipcode-form"
      autocomplete="off"
      @submit.prevent="submitBlog()"
    >
      <fieldset class="form-group">
        <label for="page-title">Category</label>
        <select
          class="form-control"
          name="category"
          id="category"
          @change="handleCat"
          :value="category"
          required
        >
          <option value="">Select category</option>
          <option
            v-for="[key, value] in getCatOptions"
            :key="key"
            :value="value"
            >{{ value }}</option
          >
        </select>
      </fieldset>
      <fieldset class="form-group">
        <label for="title">Title</label>
        <input
          id="title"
          class="form-control"
          type="text"
          v-model="title"
          name="title"
        />
      </fieldset>
      <div class="form-group form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="featured"
          v-model="isActive"
        />
        <label class="form-check-label" for="featured">Active</label>
      </div>
      <div class="form-group form-check">
        <input
          type="date"
          class="form-check-input"
          id="featured"
          :value="formattedPostDate"
          @input="updatePostDate"
        />
        <label class="form-check-label" for="featured">Post Date</label>
      </div>

      <fieldset class="form-group">
        <label for="pageUrl">Page Url</label>
        <input
          id="pageUrl"
          class="form-control"
          type="text"
          v-model="pageUrl"
          name="pageUrl"
        />
      </fieldset>

      <fieldset class="form-group">
        <label for="cover-image">Cover Image</label>
        <div class="form-group form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="isCoverImageNotShow"
            v-model="isCoverImageNotShow"
          />
          <label class="form-check-label" for="isCoverImageNotShow"
            >Do NOT show the Cover Image on the article page.</label
          >
        </div>
        <input
          ref="fileInput"
          id="cover-image"
          accept="image/png,image/jpeg,image/jpg"
          type="file"
          autocomplete="off"
          tabindex="-1"
          style="display: none;"
          @change="onChangeFileInput"
        />
        <div>
          <CButton
            class="btn btn-outline-secondary"
            @click="choosePhoto"
            :disabled="uploadLoading"
          >
            Choose a cover image
          </CButton>
          <span> *Image size should be 16:9 ratio, and at least 1280x720.</span>
        </div>

        <div>
          <img
            :src="coverImageSrc"
            alt=""
            v-if="!!coverImageSrc"
            style="max-width: 100px; max-height: 100px; margin-top: 10px;"
          />
        </div>
      </fieldset>
      <p :if="!!coverImgErrorMsg" class="text-danger">{{ coverImgErrorMsg }}</p>

      <fieldset class="form-group">
        <label for="cover-img-alt">Cover Image Alt</label>
        <input
          id="cover-img-alt"
          class="form-control"
          type="text"
          v-model="coverImgAlt"
          name="coverImgAlt"
        />
      </fieldset>

      <fieldset class="form-group">
        <label for="page-title">Page Title</label>
        <input
          id="page-title"
          class="form-control"
          type="text"
          v-model="pageTitle"
          name="pageTitle"
        />
      </fieldset>

      <fieldset class="form-group">
        <label for="meta-description">Meta Description</label>
        <input
          id="meta-description"
          class="form-control"
          type="text"
          v-model="metaDescription"
          name="metaDescription"
        />
      </fieldset>

      <fieldset class="form-group">
        <label for="meta-keywords"
          >Meta Keywords (Separate keywords by comma)</label
        >
        <input
          id="meta-keywords"
          class="form-control"
          type="text"
          v-model="metaKeywords"
          name="metaKeywords"
        />
      </fieldset>

      <div class="form-group form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="featured"
          v-model="featured"
        />
        <label class="form-check-label" for="featured">Featured</label>
      </div>

      <fieldset class="form-group">
        <label for="content">Content</label>
        <TinymceEditor :value="content" @input="content = $event" />
        <!-- <ckeditor
          :editor="editor"
          v-model="content"
          :config="editorConfig"
          aria-placeholder="Please type here..."
        >
        </ckeditor> -->
      </fieldset>

      <button
        type="submit"
        class="btn btn-primary btn-lg submit d-block ml-auto mr-auto"
        :class="{ disabled: isDisabled }"
        :disabled="isDisabled"
      >
        Save
      </button>
    </form>
  </div>
</template>

<script>
// import ClassicEditor from 'ckeditor5-build-classic-base64-upload-adapter'
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { createBlogMixin, blogsStore } from "@/mixins/blogsMixin";
import { modalStore } from "@/mixins/modalsMixin";
import localStorage from "@/utils/localStorage";
import API from "@/api";
import slugify from "slugify";
import { readAsDataURL } from "@/utils/AsyncFileReader";
import moment from "moment";
import enumVariabls from "@/constants/enum";
import TinymceEditor from "@/components/TinymceEditor.vue";

export default {
  name: "VBlogForm",
  mixins: [createBlogMixin()],
  components:{TinymceEditor},
  data() {
    return {
      title: "",
      content: "",
      pageUrl: "",
      coverImgAlt: "",
      coverImageSrc: "",
      pageTitle: "",
      metaDescription: "",
      metaKeywords: "",
      featured: false,
      isDisabled: false,
      uploadLoading: false,
      coverImgErrorMsg: "",
      isActive: false,
      category: "",
      postDate: new Date().toISOString(),
      editor: ClassicEditor,
      isCoverImageNotShow: false,
      editorConfig: {
        // extraPlugins: [ MyCustomUploadAdapterPlugin ],
        // The configuration of the editor.
        // extraPlugins: 'youtube'
        ckfinder: {
          // The URL that the images are uploaded to.
          uploadUrl: "/uploads",
          // Enable the XMLHttpRequest.withCredentials property.
          // withCredentials: true,

          // Headers sent along with the XMLHttpRequest to the upload server.
          headers: {
            // "X-CSRF-TOKEN": "CSFR-Token",
            Authorization: `${localStorage.getToken()}`
          }
        }
      }
    };
  },
  props: {
    isCloseModal: {
      type: Boolean
    },
    blog: {
      type: Object,
      default: null
    }
  },
  watch: {
    isCloseModal(){
      this.resetData()
    },
    blog() {
      console.log("this.$props.blog", this.$props.blog);
      if (this.$props.blog) {
        this.title = this.$props.blog.title || "";
        this.content = this.$props.blog.content || "";
        this.coverImageSrc =
          this.$props.blog.coverImage || this.$props.blog.cover_image || "";
        this.coverImgAlt =
          this.$props.blog.coverImgAlt || this.$props.blog.cover_img_alt || "";

        this.pageTitle =
          this.$props.blog.pageTitle || this.$props.blog.page_title || "";
        this.metaDescription =
          this.$props.blog.metaDescription ||
          this.$props.blog.meta_description ||
          "";
        this.metaKeywords =
          this.$props.blog.metaKeywords || this.$props.blog.meta_keywords || "";
        this.pageUrl =
          this.$props.blog.pageUrl || this.$props.blog.page_url || "";
        this.featured = this.$props.blog.featured || false;
        this.isActive = this.$props.blog.isActive || false;
        this.postDate =
          this.$props.blog.postDate || this.$props.blog.post_date || new Date();
        this.postDate = moment(this.postDate).toDate();
        this.category = this.$props.blog.category;
        this.isCoverImageNotShow = this.$props.blog.isCoverImageNotShow;
      }
    },
    title() {
      this.pageUrl = slugify(this.title, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: false, // convert to lower case, defaults to `false`
        strict: true, // strip special characters except replacement, defaults to `false`
        locale: "vi", // language code of the locale to use
        trim: true // trim leading and trailing replacement chars, defaults to `true`
      });
    }
  },
  methods: {
    handleCat(e) {
      this.category = e.target.value;
    },
    updatePostDate(event) {
      // Update the postDate when the user selects a new date
      const selectedDate = event.target.value;
      this.postDate = new Date(selectedDate).toISOString();
    },
    resetData() {
      this.title = "";
      this.content = "";
      this.pageUrl = "";
      this.coverImgAlt = "";
      this.coverImageSrc = "";
      this.pageTitle = "";
      this.metaDescription = "";
      this.metaKeywords = "";
      this.featured = false;
      this.isDisabled = false;
      this.uploadLoading = false;
      this.coverImgErrorMsg = "";
      this.category = "";
      this.isActive = false;
      this.isCoverImageNotShow = false;
      this.postDate = new Date().toISOString();
    },
    async submitBlog() {
      const isUpdateReq = this.$props.blog && this.$props.blog.id;
      try {
        this.isDisabled = true;
        const blogObj = {
          title: this.title,
          content: this.content,
          coverImage: this.coverImageSrc,
          coverImgAlt: this.coverImgAlt,
          pageTitle: this.pageTitle,
          metaDescription: this.metaDescription,
          metaKeywords: this.metaKeywords,
          pageUrl: this.pageUrl,
          featured: this.featured,
          isActive: this.isActive,
          postDate: this.postDate,
          category: this.category,
          isCoverImageNotShow: this.isCoverImageNotShow
        };
        if (isUpdateReq) {
          const blogId = this.$props.blog.id;
          await this[blogsStore.actionTypes.ACTION_EDIT_BLOG]({
            blogId,
            blog: blogObj
          });
        } else {
          await this[blogsStore.actionTypes.ACTION_ADD_BLOG](blogObj);
        }
        this.resetData();
        this.closeModal();
      } catch (error) {
        console.log(error);
        console.log(error.response);
      } finally {
        this.isDisabled = false;
      }
    },
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        );
      }, 500);
      this.resetData()
      this.$modals.close();
    },
    choosePhoto() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    checkImageSize(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = src;

    image.onload = function () {
      const { width, height } = this;

      // Validate Minimum Dimensions
      if (width < 1280 || height < 720) {
        reject({
          imgSize: true,
          message: "Image must be at least 1280x720 pixels."
        });
        return;
      }

      // Validate Aspect Ratio (16:9)
      const aspectRatio = width / height;
      const expectedRatio = 16 / 9;

      // Allow small floating-point differences
      const epsilon = 0.01; 

      if (Math.abs(aspectRatio - expectedRatio) > epsilon) {
        reject({
          imgRatio: true,
          message: "Image must have a 16:9 aspect ratio."
        });
        return;
      }

      // Validation Passed
      resolve("Image meets the size and ratio requirements.");
    };

    image.onerror = function () {
      reject({
        imgLoad: true,
        message: "Failed to load image. Please ensure the file is valid."
      });
    };
  });
}
,
    async onChangeFileInput(event) {
      try {
        this.uploadLoading = true;
        const file = event.target.files[0];
        const imgBase64 = await readAsDataURL(event.target.files[0]);
        await this.checkImageSize(imgBase64);
        this.coverImgErrorMsg = "";
        const formData = new FormData();
        formData.append("upload", file);

        const { data } = await API.blogManager.uploadCoverImage(formData);
        this.coverImageSrc = data.url;
      } catch (error) {
        console.log(error);
        if (error && error.imgSize) {
          this.coverImgErrorMsg =
            error.message;
        }
        this.coverImageSrc = "";
      } finally {
        this.uploadLoading = false;
      }
    }
  },
  computed: {
    getCatOptions() {
      return Object.entries(enumVariabls.featureContentCat);
    },
    formattedPostDate() {
      // Extract the date part from the received date
      const datePart = new Date(this.postDate).toISOString().split("T")[0];
      return datePart;
    }
  }
};
</script>
